import { Flex } from '@chakra-ui/react'
import { usePracticeContext } from '@hb/react'
import { midwivesCollection } from '@hb/shared'
import { midwifeFields } from '../../collections/fields/practice'
import { useUpdateCollection } from '../../hooks/useAppCollections'
import { DataView } from '../DataView'

export const LegacyMidwifeView = () => {
  const { practice: provider } = usePracticeContext()
  const { updateItem } = useUpdateCollection(midwivesCollection)
  return (
    <Flex w="100%" direction="column">
      <DataView
        onSubmit={v => updateItem(provider?.id ?? '', '', v)}
        data={provider}
        field={midwifeFields}
      />
    </Flex>
  )
}
